<template>
  <div>
    <v-card>
      <v-alert
        class="text-center mt-4"
        color="blue accent-2"
        elevation="2"
        dark
      >
        รายชื่อนักเรียนที่สมัครเข้าศึกษา<br />ระดับชั้นมัธยมศึกษาปีที่ 1
        <br />(ในเขตพื้นที่บริการ)
      </v-alert>
      <v-card-title>
        <v-text-field
          v-model="searchArea"
          append-icon="mdi-magnify"
          label="ค้นหา"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="studentArea"
        :search="searchArea"
      ></v-data-table>
    </v-card>

    <v-card>
      <v-alert
        class="text-center mt-4"
        color="teal lighten-1"
        elevation="2"
        dark
      >
        รายชื่อนักเรียนที่สมัครเข้าศึกษา<br />ระดับชั้นมัธยมศึกษาปีที่ 1
        <br />(นอกเขตพื้นที่บริการ)
      </v-alert>
      <v-card-title>
        <v-text-field
          v-model="searchOutArea"
          append-icon="mdi-magnify"
          label="ค้นหา"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="studentOutArea"
        :search="searchOutArea"
      ></v-data-table>
    </v-card>

    <v-card>
      <v-alert class="text-center mt-4" color="cyan" elevation="2" dark>
        รายชื่อนักเรียนที่สมัครเข้าศึกษา<br />ระดับชั้นมัธยมศึกษาปีที่ 4
      </v-alert>
      <v-card-title>
        <v-text-field
          v-model="searchM4"
          append-icon="mdi-magnify"
          label="ค้นหา"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="studentM4"
        :search="searchM4"
      ></v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    searchArea: '',
    searchOutArea: '',
    searchM4: '',
    headers: [
      {
        text: 'ลำดับที่ผู้สมัครสอบ',
        align: 'center',
        value: 'id',
      },
      { text: 'คำนำหน้า', value: 'prefix' },
      { text: 'ชื่อ', value: 'name' },
      { text: 'นามสกุล', value: 'lastname' },
    ],
    studentArea: [],
    studentOutArea: [],
    studentM4: [],
  }),
  mounted() {
    let vm = this
    axios
      .get('https://huahin.ac.th/service/hhreg/api/read.php?grade=area')
      .then(function (resp) {
        vm.studentArea = resp.data.response
      })
    axios
      .get('https://huahin.ac.th/service/hhreg/api/read.php?grade=outarea')
      .then(function (resp) {
        vm.studentOutArea = resp.data.response
      })
    axios
      .get('https://huahin.ac.th/service/hhreg/api/read.php?grade=m4')
      .then(function (resp) {
        vm.studentM4 = resp.data.response
      })
  },
}
</script>
